import { Checkbox } from '@material-ui/core';

const CheckboxCell = ({ row, isChecked, handleClickRow }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Checkbox
        checked={Boolean(isChecked)}
        onChange={() => {
          handleClickRow(row);
        }}
        color="primary"
      />
    </div>
  );
};

export default CheckboxCell;
